<template>
  <section class="has-text-default mt-40 mx-20">
    <div class="level">
      <div class="level-left">
        <div class="level-item mr-20">
           <a @click="$router.push({ name: 'liste-client' })">
            <b-icon icon="chevron-left" type="is-default"></b-icon>
            <span class="has-text-grid-1 has-text-weight-bold is-size-4 ml-10">
              {{titlePage}}
            </span>
          </a>
        </div>
      </div>
      <div class="level-right">
        <b-button type="is-primary"
          class="has-text-weight-bold"
          @click="modifClient">
          {{$t('infoClient.btnModifier')}}
        </b-button>
        <b-button type="is-primary"
          v-if="afficheButton"
          class="has-text-weight-bold ml-2"
          icon-left="link-variant"
          @click="copyLink">
          {{$t('infoClient.btnCopieLien')}}
        </b-button>
        <b-button type="is-primary"
          v-if="afficheButton"
          class="has-text-weight-bold ml-2"
          icon-left="open-in-new"
          @click="openLink">
          {{$t('infoClient.btnOuvrirLien')}}
        </b-button>
      </div>
    </div>
    <information-client
      :client="client"
      :logo="logo"
      v-if="logo"/>
     <listes-composants
      v-if="client.num"
      :societe-id="client.societeId"></listes-composants>
    <ModifClient
      v-if="modifClientActive"
      @close="modifClientActive = false"
      @update="getClient"
      :typeClient="typeClient"
      is-modif/>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { gestionDev } from '@/services/general/general';
import InformationClient from '@/components/client/detailClient/informationsClient.vue';
import ListesComposants from '@/components/client/detailClient/listesComposants.vue';
import { browseDetailClient } from '@/api/clients/index';
import { buildLinkPortail } from '@/api/devis/index';
import * as config from '@/configuration/clientConf';
import gestionErreur from '@/services/general/gestionErreur';
import ModifClient from '@/views/client/creerClient.vue';
import * as types from '@/store/modules/client-mutation-type'
import getLogoClient from '@/services/general/getLogoClient';
import generer from '@/services/client/genererTiers';
import { APPLICATION_TVA_TYPE_NORMAL } from '@/configuration/applicationTvaConf';

const Client = createNamespacedHelpers('client');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    InformationClient,
    ListesComposants,
    ModifClient,
  },
  data: () => ({
    client: {},
    logo: null,
    modifClientActive: false,
    config,
    typeClient: ''
  }),
  computed: {
    titlePage() {
      const type = this.$route.params.type;
      if (type === config.ENSEIGNE) return this.$i18n.t('infoClient.titlePageEnseigne');
      if (type === config.POINT_VENTE) return this.$i18n.t('infoClient.titlePagePDV');
      return this.$i18n.t('infoClient.titlePage');
    },
    afficheButton() {
      const type = this.$route.params.type;
      if (type !== config.POINT_VENTE) return true;
      return false;
    },
  },
  methods: {
    ...Client.mapMutations({
      setClient: types.SET_CLIENT,
      setElementId: types.SET_ELEMENT_ID,
      videPJ: types.VIDER_PJ,
    }),
    ...Client.mapActions({
      setPJElementId: 'setElementId',
    }),
    ...Societe.mapActions({
      setSocieteId: 'setSocieteId',
    }),
    gestionDev: () => gestionDev(),
    async getLienPortail() {
      const id = this.$route.params.id;
      const type = this.$route.params.type;
      return (await buildLinkPortail(id, type)).data.result;
    },
    async copyLink() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const lien = await this.getLienPortail();
        await navigator.clipboard.writeText(lien);
        this.$buefy.toast.open({
          message: this.$t('general.msgLienCopie'),
          type: 'is-success' });
        loadingComponent.close();
      } catch (error) {
        this.$buefy.toast.open({
          message: this.$t('general.msgLienNonCopie'),
          type: 'is-danger' });
        loadingComponent.close();
      }
    },
    async openLink() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const lien = await this.getLienPortail();
        window.open(lien);
      } catch (error) {
        gestionErreur('Erreur lors de la construction du lien portail', error);
      } finally {
        loadingComponent.close();
      }
    },
    async getClient() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const id = this.$route.params.id;
        this.client = (await browseDetailClient(id)).data;
        this.logo =  (await getLogoClient(this.client)).logo;
        loadingComponent.close();
      } catch (error) {
        gestionErreur(`Erreur lors de la récupération du client id: ${this.$route.params.id}`, error);
        loadingComponent.close();
      }
    },
    async modifClient() {
      this.typeClient = this.client.typologie;
      const client = { ...generer(), ...cloneDeep(this.client) };
      client.srcImg = this.logo.chemin;
      client.urlLogo = this.logo.chemin;
      client.applicationTva = client.applicationTva || APPLICATION_TVA_TYPE_NORMAL;
      this.setClient(client);
      this.videPJ();
      this.setElementId(this.client.num);
      this.setSocieteId(this.client.societeId);
      this.modifClientActive = true;
    }
  },
  mounted() {
    this.getClient();
  }
}
</script>

<style>

</style>
